import { Route, Routes } from "react-router-dom";

import { MainRoutes } from "./main-routes";
import Login from "../features/authentication/Login";
import { LoginPage } from "../features/authentication/login-page";

import { LogoutRedirect } from "../features/authentication/logout-redirect";
import { LoginWithCognito } from "../features/authentication/login-aws";
import { useAuth } from "react-oidc-context";
import { StorageKey } from "../constants";
import Logo from "../assets/images/logo-keystone";
import { MenuLandingComponent } from "./menu-landing";
import DarkVariantExample from "./image-curosel";
import { _GET_UNION_NAME } from "../models/common/cognitoAuthConfig";
import AppSidebar from "./sidenavbar-menu";

export const RouterView = () => {
  const auth = useAuth();
  const unionName = _GET_UNION_NAME(window?.location?.hostname)?.toUpperCase();
  if (auth.isLoading) {
    return (
      <div>
        <h4>Loading...</h4>
      </div>
    );
  }
  if (auth.error) {
    auth.clearStaleState();
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {

    const sid = auth.user?.profile?.sub

   // alert(sid);
    console.log("auth", auth)

    localStorage.setItem(
      StorageKey.AuthState,
      JSON.stringify(auth.user?.id_token)
    );
    localStorage.setItem(
      StorageKey.Profile,
      JSON.stringify(auth?.user?.profile)
    );
    return (
      <Routes>
        <Route path="/*" element={<MainRoutes menuType="admin" />} />
      </Routes>
    );
  }

  return (
    <>
      <div className="header">
        <nav className="navbar navbar-expand-sm navbar-toggleable-sm  bg-white border-bottom box-shadow">
          <div className="container-fluid d-flex">
            <div className="navbar-brand" style={{ marginLeft: "-5px" }}>
              <Logo />
            </div>
            <div className="menu-title">
              <h4>{unionName && unionName + " DCMPU"}</h4>
            </div>
            <div className="ms-auto d-flex">
              <MenuLandingComponent onSignIn={() => auth.signinRedirect()} ></MenuLandingComponent>
              {/* <AppSidebar></AppSidebar> */}
            </div>
          </div>
        </nav>
      </div>
      <div className="m-1 landing-main-bg">
        <div
          className="p-4 "
          style={{
            height: "400px",
            width: "100%",
            borderRadius: "10px"
          }}
        >
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              border: "1px solid rgb(0, 200, 255);",

            }}
          >
            <DarkVariantExample></DarkVariantExample>
          </div>
        </div>
      </div>
    </>
  );
};
